export function thumbsOptions(config) {
  const { slidesLength } = config;
  return {
    init: false,
    loop: true,
    slideToClickedSlide: true,
    slidesPerView: 'auto',
    spaceBetween: 11,
    loopedSlides: slidesLength,
    centeredSlides: true,
  }
}

export function mainOptions(config) {
  const { slidesLength, next, prev } = config;
  return {
    slidesPerView: 1,
    loopedSlides: slidesLength,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: next,
      prevEl: prev,
    },
    lazy: {
      loadPrevNext: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  }
}
